/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
import { Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const AuthNavBar: React.FC = () => {
    // function that sets the class to active of the active page
    function activeRoute(routeName) {
        return window.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    }

    // function that shows/hides sidebar on responsive
    function mobileSidebarToggle(e) {
        document.documentElement.classList.toggle("nav-open");
    }

    return (
        <Navbar collapseOnSelect className="navbar-primary navbar-transparent navbar-absolute" >
            <div className="navbar-header">
                <Navbar.Brand>
                    <NavLink to={"/plm/home"} className="nav-link">
                        PLM
                    </NavLink>
                </Navbar.Brand>
                <Navbar.Toggle onClick={mobileSidebarToggle} />
            </div>
            <Navbar.Collapse>
                <ul className="nav navbar-nav navbar-right">
                    <li className={activeRoute("login")}>
                        <NavLink to={"/auth/login"} className="nav-link">
                            <i className="fa fa-drivers-license-o" />
                            <p>Login</p>
                        </NavLink>
                    </li>
                    <li className={activeRoute("register-page")}>
                        <NavLink to={"/auth/register"} className="nav-link">
                            <i className="fa fa-user-circle-o" />
                            <p>Register</p>
                        </NavLink>
                    </li>
                </ul>
            </Navbar.Collapse>
        </Navbar>
    );
}
export default AuthNavBar;